import React from 'react';

export interface AmenityType {
  icon: React.ReactNode;
  active: boolean;
  title: string;
}

export enum ExtraAmenityType {
  People = 'people',
  GeneralCondition = 'generalCondition',
  QualityClass = 'qualityClass',
  Parking = 'parking',
  AirDirection = 'airDirection',
  BalconyAreas = 'balconyAreas',
  GardenAreas = 'gardenAreas',
  WarehouseAreas = 'warehouseAreas',
  Bathroom = 'bathroom',
  Toilet = 'toilet',
}
